export class TechnologiesConfig {
  private readonly _apiUrl: string

  constructor() {
    this._apiUrl = "/api/technologies"
  }

  public get apiUrl() {
    return this._apiUrl
  }
}
